import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import MainLayout from '../Smart/Layouts/MainLayout';
import UserProfileSidebar from './UserProfileSidebar';
import UserProfilePage from './UserProfilePage';
import paths from '../../lib/consts/paths';
import UserProfileOrders from './UserProfileOrders';
import CwTrainingEmails from './CwTrainingEmails/CwTrainingEmails';

const UserProfileLayout: FC = () => {
	const { page = '' } = useParams();
	const { profile, orders, trainingEmails } = paths.userProfile.params;
	const pages = {
		[profile]: <UserProfilePage />,
		[orders]: <UserProfileOrders />,
		[trainingEmails]: <CwTrainingEmails />,
	};
	const content = pages[page];
	const sidebar = <UserProfileSidebar />;

	return <MainLayout sidebar={sidebar} content={content} />;
};

export default UserProfileLayout;
